import { CSSProgressiveHeading01 } from "@caisy/league";
import styled from "styled-components";

export const SCreateProjectModalFirstStepItemTitle = styled.div`
  ${CSSProgressiveHeading01};
  color: var(--text-01);
  width: 100%;
`;
